module.exports = __webpack_public_path__ + "img/big3-12.6f751684.jpg";